import { render, staticRenderFns } from "./VPageSubtitle.vue?vue&type=template&id=078fe4d0&"
import script from "./VPageSubtitle.vue?vue&type=script&lang=js&"
export * from "./VPageSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports